import { UserStore, useUserSubprofilesSelector } from "@nf/common";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useCountry } from "hooks";

export const useParentalRatings = () => {
  const dispatch = useDispatch();
  const country = useCountry();

  const { Data, IsProcessing } = useUserSubprofilesSelector();

  const parentalRatings = Data?.parentalRatings;

  useEffect(() => {
    if (!parentalRatings?.length && country) {
      dispatch(UserStore.Actions.getUserParentalRatings(country));
    }
  }, [dispatch, parentalRatings?.length, country]);

  return {
    data: parentalRatings,
    isLoading: IsProcessing,
  };
};
